import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { photos } from '../data/site';
import { lessons } from '../data/content';
import { PageIntro } from '../components/ui/PageIntro';
import { ButtonLink } from '../components/ui/ButtonLink';
import { Faq } from '../components/ui/Faq';
import { CtaBand } from '../components/ui/CtaBand';
export function Lessons() {
  usePageTitle('Piano- en gitaarles in Huizen');
  return <>
      <PageIntro eyebrow="Muziekles · piano & gitaar in Huizen" title={<>
            Jij kiest het liedje. <em className="text-amber" data-id="element-340" data-mp="w3qi6grqow63">Ik de route.</em>
          </>} intro="Met veel plezier deel ik mijn passie voor gitaar en piano. Beginner of gevorderd, jong of oud: je bent nooit te oud om te leren spelen. Als conservatorium-opgeleid docent geef ik les die bij jou past." image={{
      src: photos.piano,
      alt: 'Bas lachend aan de piano',
      position: '50% 30%'
    }} data-id="element-339" data-mp="s4zic1vw30fa">
        <ButtonLink to="/contact?type=muziekles" arrow data-id="element-341" data-mp="37tj58jarb2zi">
          Meld je aan
        </ButtonLink>
        <a href="#tarieven" className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-line px-6 py-3.5 text-sm font-semibold text-paper transition-colors duration-150 hover:border-sand" data-id="element-342" data-mp="3uxh4k19p3fdk">
          Bekijk tarieven
        </a>
      </PageIntro>

      <section aria-labelledby="claim-title" className="w-full bg-paper text-ink" data-id="element-343" data-mp="housnp5sc7x3">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-344" data-mp="hmrqk6rcyoc0">
          <div className="lg:col-span-6" data-id="element-345" data-mp="reo3up20ml0t">
            <h2 id="claim-title" className="font-serif text-5xl leading-[1.02] tracking-tight md:text-6xl" data-id="element-346" data-mp="rdmh3nbn0a39">
              “Ik durf te claimen dat ik iedereen binnen <em className="text-amber-deep" data-id="element-347" data-mp="mhxefb4bmd2q">één les</em> een Top 40-hit kan aanleren.”
            </h2>
            <p className="mt-6 max-w-md text-[17px] leading-relaxed text-ink/70" data-id="element-348" data-mp="wdqyrgoa7av2">
              Want laten we eerlijk zijn: je wilt al snel iets laten horen aan vrienden en familie. Het belangrijkste is plezier.
            </p>
          </div>
          <ul className="lg:col-span-5 lg:col-start-8" data-id="element-349" data-mp="18h3cbvkx5vq9">
            {lessons.approach.map(a => <li key={a.title} className="border-t border-ink/15 py-6 last:border-b" data-id="element-350" data-mp="1de3gu224eqf9">
                <h3 className="font-serif text-3xl" data-id="element-351" data-mp="1i64unsexsp7e">{a.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-ink/70" data-id="element-352" data-mp="1n4y5fd2ua23v">{a.text}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section id="tarieven" aria-labelledby="prices-title" className="w-full scroll-mt-20 bg-ink" data-id="element-353" data-mp="1r4yml5hborem">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-354" data-mp="1w6fj6osrxrpe">
          <div className="lg:col-span-4" data-id="element-355" data-mp="212mpiip3157v">
            <h2 id="prices-title" className="font-serif text-5xl leading-[1.02] tracking-tight text-paper" data-id="element-356" data-mp="1selw8cvhcrf">
              Tarieven
            </h2>
            <p className="mt-5 max-w-sm text-[17px] leading-relaxed text-sand" data-id="element-357" data-mp="6qy6o5fqcii7">
              Helder en zonder verplichtingen vooraf. Twijfel je over de lengte? We bepalen het samen na een eerste kennismaking.
            </p>
          </div>
          <div className="lg:col-span-8" data-id="element-358" data-mp="3lm8d8dbuk71q">
            <table className="w-full border-collapse text-left" data-id="element-359" data-mp="3ln9nifl1gpie">
              <caption className="sr-only" data-id="element-360" data-mp="3gogb6qhhn4jt">Lestarieven piano en gitaar</caption>
              <thead data-id="element-361" data-mp="i5rjkj8e02n9">
                <tr className="border-b border-line text-xs uppercase tracking-[0.12em] text-muted" data-id="element-362" data-mp="i6b2o39rwx2v">
                  <th scope="col" className="pb-4 font-semibold" data-id="element-363" data-mp="d7zrnp7qsgj2">Lesduur</th>
                  <th scope="col" className="hidden pb-4 font-semibold sm:table-cell" data-id="element-364" data-mp="87lksahvncmm">Geschikt voor</th>
                  <th scope="col" className="pb-4 text-right font-semibold" data-id="element-365" data-mp="39a7fpsdijzn">Per les</th>
                </tr>
              </thead>
              <tbody data-id="element-366" data-mp="2syvrg5dig39h">
                {lessons.prices.map(p => <tr key={p.duration} className="border-b border-line" data-id="element-367" data-mp="2nyhr79i5hxm0">
                    <th scope="row" className="py-8 font-serif text-3xl font-normal text-paper md:text-4xl" data-id="element-368" data-mp="2o1c9ovhlt8cs">{p.duration}</th>
                    <td className="hidden py-8 pr-6 text-[15px] text-sand sm:table-cell" data-id="element-369" data-mp="lf181tm45puc">{p.note}</td>
                    <td className="py-8 text-right font-serif text-4xl text-amber md:text-5xl" data-id="element-370" data-mp="6q4yfs4es4rm">{p.price}</td>
                  </tr>)}
              </tbody>
            </table>
            <p className="mt-6 text-sm text-muted" data-id="element-371" data-mp="zek59rddzgrv">Pianoles en gitaarles hebben hetzelfde tarief.</p>
          </div>
        </div>
      </section>

      <section aria-labelledby="lesson-faq-title" className="w-full border-t border-line bg-stage" data-id="element-372" data-mp="14cvdjxo19j7z">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-373" data-mp="pfl0wkznm7ao">
          <div className="lg:col-span-4" data-id="element-374" data-mp="uhag8ctwt74k">
            <h2 id="lesson-faq-title" className="font-serif text-5xl leading-[1.02] tracking-tight text-paper" data-id="element-375" data-mp="3a5tyui1quniz">
              Goed om te weten
            </h2>
            <img src={photos.guitarPlaying} alt="Bas speelt gitaar" className="mt-10 hidden aspect-[4/3] w-full rounded-sm object-cover lg:block" data-id="element-376" data-mp="3f3bzzm9irygf" />
          </div>
          <div className="lg:col-span-8" data-id="element-377" data-mp="1s7xbwen21895">
            <Faq items={lessons.faq} data-id="element-378" data-mp="1sb307rnv063t" />
          </div>
        </div>
      </section>

      <CtaBand title="Zin om te beginnen?" text="Stuur een berichtje of bel even. Dan plannen we een eerste les op een moment dat jou uitkomt." to="/contact?type=muziekles" label="Meld je aan voor les" data-id="element-379" data-mp="267ou6rkltasy" />
    </>;
}